import styled, { css } from 'styled-components'
import { themeStyles } from '../../../styles/theme'

export const StyledWrapper = styled.label`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  background-color: ${({ $isChecked }) =>
    $isChecked
      ? themeStyles.colors.lightGreys[1].main
      : themeStyles.colors.white.main};
  border: 1px solid ${themeStyles.colors.lightGreys[1].main};
  min-height: 95px;
  border-radius: 6px;
  padding: 16px;
  box-sizing: border-box;
  justify-content: space-between;
  gap: 20px;

  ${(props) =>
    props.$isDeposit &&
    css`
      background-color: ${themeStyles.colors.white.main};
    `}
`

export const StyledContent = styled.div`
  ${(props) =>
    props.$isDisabled &&
    css`
      color: ${themeStyles.colors.lightGreys[3].main};
    `}

  p {
    font-size: 16px;
    line-height: 18px;
    margin: 0;
  }
`

export const StyledIconWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  ${(props) =>
    props.$isDisabled &&
    css`
      filter: brightness(1) saturate(0);
      opacity: 0.5;
    `}
  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    border-radius: 50%;
  }
`
